export const worksheetFieldsGridStyles = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
  columnGap: '24px',
  alignItems: 'start',
};

export const worksheetFullWidthFieldStyles = {
  gridColumn: '1 / -1',
};

export const worksheetSectionStyles = {
  '&:not(:first-of-type)': {
    marginTop: '8px',
    paddingTop: '16px',
    borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  },
};
